import { render, staticRenderFns } from "./tzgg-card.vue?vue&type=template&id=fea8122e&"
import script from "./tzgg-card.vue?vue&type=script&lang=js&"
export * from "./tzgg-card.vue?vue&type=script&lang=js&"
import style0 from "./tzgg-card.vue?vue&type=style&index=0&id=fea8122e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports